<div class="flex flex-col gap-2" tabIndex="-1"
     [hidden]="storeField?.IsHidden">
    @if (displayCaption && !isGridControl && !storeField?.IsHidden) {
        <label class="flex gap-1 text-sm font-semibold" [for]="storeField?.Id">
            <span>
                <span [innerHTML]="storeField?.Caption"></span>
                @if (storeField?.aiGeneration !== undefined) {
                    @if (storeField?.aiGeneration?.aiValue !== undefined) {
                        @if (storeField?.aiGeneration?.confirmed) {
                            <i class="ml-2 text-sm text-green-500 fa-solid fa-microchip-ai"></i>
                        } @else if (storeField?.aiGeneration?.confirmed !== undefined) {
                            <i (click)="setAiButtonAcceptance(storeField, $event)"
                               class="ml-2 text-sm text-blue-500 fa-solid fa-microchip-ai hover:cursor-pointer"></i>
                        }
                    } @else if (storeField?.aiGeneration?.generated) {
                        <bizz-tooltip
                                class="ml-2 relative -top-2 inline-flex h-5 cursor-pointer text-xl leading-4 text-orange-400"
                                text="{{'AiCouldNotProcess' | translate }}"></bizz-tooltip>
                    }
                }
                @if (storeField?.IsRequired) {
                    <span class="-top-0.5 h-5 text-xl leading-4 text-red-400 ml-2">*</span>
                }
                @if (errorState?.AiValidationError === undefined && errorState?.Message; as errorMessage) {
                    <bizz-tooltip
                            class="ml-2 relative -top-2 inline-flex h-5 cursor-pointer text-xl leading-4 text-red-400"
                            [text]="errorMessage"></bizz-tooltip>
                }
                @if (storeField && storeField.Hint) {
                    <bizz-popup class="ml-2 relative -top-2 inline-flex h-5 cursor-pointer"
                                [title]="storeField?.Caption" [body]="storeField.Hint"></bizz-popup>
                }
            </span>
        </label>
    }
    <div class="flex min-w-full relative" tabIndex="-1">
        <!-- Loa
        der based on store IsLoading state, except for grids which have their own loading implementation -->
        <!-- <bizz-loader [size]="8" [showLoader]="!!storeField?.IsLoading && !isGrid" [backgroundClasses]="'bg-form/50'"></bizz-loader> -->
        @if (!!storeField?.IsLoading && !hasOwnLoader) {
            <div class="absolute left-0 top-0 z-40 h-full w-full bg-form/50">
                <div class="absolute left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2 transform">
                </div>
            </div>
        }
        <ng-container viewContainerRef>
        </ng-container>
    </div>
</div>

